<template lang="pug">
.send-emergency-transport-patient-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：送信日時
    template(#cell(created)="row")
      span {{ formatCreated(row.item.created) }}

    // セル：操作
    template(#cell(operation)="row")
      .d-flex.justify-content-center.align-items-center
        button.btn.detail-btn.mr-2(@click="onDetail(row.item)" type="button") 詳細
        button.btn.print-btn(@click="onPrint(row.item)" type="button") 印刷
</template>

<script lang="ts">
import { EmergencyTransportPatientModel } from "@/commons/services/EmergencyTransportPatients";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 送信側：救急搬送患者テーブルコンポーネント
 */
@Component({})
export default class SendEmergencyTransportPatientTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<SendEmergencyTransportPatientTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<SendEmergencyTransportPatientTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<SendEmergencyTransportPatientTableItem> {
    return this.value;
  }

  /**
   * ### 送信日時のフォーマット
   */
  public formatCreated(created: number): string {
    if (!created) return "";
    return this.$dateUtil.convertNumberToString(created, "yyyy年mm月dd日 hh:MM");
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: SendEmergencyTransportPatientTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(row, filter);
  }

  private filterSearchWords(row: SendEmergencyTransportPatientTableItem, filter: FilterSetting): boolean {
    if (!filter || !filter.searchWord || filter.searchWord === "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundTargetFacilityName: boolean = true;
    let foundName: boolean = true;

    for (const word of words) {
      if (!row.targetFacilityName || row.targetFacilityName.indexOf(word) === -1) {
        foundTargetFacilityName = false;
      }
      if (!row.name || row.name.indexOf(word) === -1) {
        foundName = false;
      }
    }

    return foundTargetFacilityName || foundName;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onDetail(patient: SendEmergencyTransportPatientTableItem): void {
    this.$emit("onDetail", patient);
    return;
  }

  /**
   * ### 印刷ボタン押下イベント
   */
  public onPrint(patient: SendEmergencyTransportPatientTableItem): void {
    this.$emit("onPrint", patient);
    return;
  }
}

/** テーブルの列名の情報 */
export interface SendEmergencyTransportPatientTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface SendEmergencyTransportPatientTableItem extends EmergencyTransportPatientModel {}

export interface FilterSetting {
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.send-emergency-transport-patient-table-component {
  .detail-btn,
  .print-btn {
    width: 64px;
  }
}
</style>
